import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import api from '@/shared/api';
import config from '@/config';
import EditableSelect from './EditableSelect';
var EditablePriceGridSelect = function (_a) {
    var _b = _a.value, value = _b === void 0 ? null : _b, onChange = _a.onChange, _c = _a.required, required = _c === void 0 ? false : _c, _d = _a.readOnly, readOnly = _d === void 0 ? false : _d, _e = _a.placeholder, placeholder = _e === void 0 ? null : _e;
    var intl = useIntl();
    var _f = useState([]), options = _f[0], setOptions = _f[1];
    useEffect(function () {
        api.base.get("".concat(config.appUrls.api, "/api/price/Grid")).then(function (_a) {
            var data = _a.data;
            setOptions((data || [])
                .map(function (x) { return ({
                id: x.id,
                label: x.name,
            }); })
                .sort(dynamicSort('label')));
        });
    }, []);
    return (_jsx(EditableSelect, { value: value, options: options, onChange: onChange, required: required, readOnly: readOnly, placeholder: placeholder }));
};
export default EditablePriceGridSelect;
